import { render, staticRenderFns } from "./document-preview.vue?vue&type=template&id=309ad6f4"
import script from "./document-preview.vue?vue&type=script&lang=js"
export * from "./document-preview.vue?vue&type=script&lang=js"
import style0 from "./document-preview.vue?vue&type=style&index=0&id=309ad6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports